import { theme, styled } from 'ui/theme';

export const CustomIcon = styled('div')`
  flex: 0 0 ${theme.sizes[4]};
`;
